export default __webpack_public_path__ + "static/pattern-1-9cd8faebc3e1153690a4fab444d9d1c0.svg";